import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import SubscriptionManager from "./SubscriptionManager";

const SubscriptionRedirectHandler = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("resubscribe");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (status === "success") {
      setMessage("✅ Subscription Updated Successfully!");
    } else if (status === "cancel") {
      setMessage("❌ Subscription Was Not Changed.");
    }
  }, [status]);

  return (
    <div className="max-w-2xl mx-auto py-8">

      {/* ✅ IntelServe Heading */}
      <h1 className="text-center text-3xl font-semibold mb-6" style={{ color: "#38bdf8" }}>
        IntelServe
      </h1>

      {message && (
        <div
          className={`mb-6 p-4 rounded text-center text-white ${
            status === "success" ? "bg-green-600" : "bg-red-600"
          }`}
        >
          {message}
        </div>
      )}

      {/* ✅ Go to Dashboard Button */}
      <div className="text-center mb-6">
        <Link
          to="/dashboard/admin"
          className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition"
        >
          Go to Dashboard
        </Link>
      </div>

      {/* Subscription Management UI */}
      <SubscriptionManager />
    </div>
  );
};

export default SubscriptionRedirectHandler;
